import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Switch } from '@/components/ui/switch'

export default function User() {
  const fields: ManageField[] = [
    {
      desc: '备注名',
      field: 'name',
    },
    {
      desc: '用户名',
      field: 'username',
    },
    {
      desc: '密码',
      field: 'password',
    },
    {
      desc: '超管',
      field: 'super',
      valuePropName: 'checked',
      initialValue: true,
      Comp: <Switch />,
      render: (val) => (val ? '是' : '否'),
    },
    {
      desc: '备注',
      field: 'desc',
    },
    {
      desc: '更新日期',
      field: 'update_time',
    },
  ]

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">用户管理</h1>
      <ManageTable fields={fields} collect="user" />
    </div>
  )
}
